enum CloudSyncStatus {
  Synced = "Synced",
  AwaitingConnection = "Not synced",
  Failed = "Failed",
}

export default CloudSyncStatus;